module.exports = __webpack_public_path__ + "img/img41.03f72886.svg";